module.exports = __webpack_public_path__ + "img/dime-quest.aa6df09a.png";